import loadScript from './loadScript';

export const initSpy = () => {
    loadScript(
        'https://b.bdstatic.com/searchbox/icms/searchbox/js/spy-client@2.0.3/spy-client-basic.min.js',
        () => {
            // eslint-disable-next-line no-undef
            window.__spyClinet = new SpyClient({
                pid: '10_75',
                sample: 1
            });
        });
};

let count = 0;
export const sendPerfLog = () => {
    let startTime = window.startTime;
    let performance = window.performance;
    if (performance && performance.timing) {
        startTime = performance.timing.navigationStart;
    }
    if (window.__spyClinet) {
        window.__spyClinet.sendPerf({
            group: 'landingpc',
            info: {
                whiteScreen: window.whiteScreenTime - startTime,
                firstScreen: window.firstScreenTime - startTime,
                domReady: window.domReadyTime - startTime,
                loaded: window.loadedTime - startTime
            }
        });
    } else {
        // 最多重试3次
        if (count < 3) {
            setTimeout(() => {
                sendPerfLog();
                count++;
            }, 1000);
        }
    }
};